import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-3 col-sm-6" }
const _hoisted_4 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_5 = { class: "card-body p-4 text-center" }
const _hoisted_6 = { class: "fs-24 fw-bold mb-1" }
const _hoisted_7 = { class: "col-lg-3 col-sm-6" }
const _hoisted_8 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_9 = { class: "card-body p-4 text-center" }
const _hoisted_10 = { class: "fs-24 fw-bold mb-1" }
const _hoisted_11 = { class: "col-lg-3 col-sm-6" }
const _hoisted_12 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_13 = { class: "card-body p-4 text-center" }
const _hoisted_14 = { class: "fs-24 fw-bold mb-1" }
const _hoisted_15 = {
  key: 0,
  class: "col-lg-3 col-sm-6"
}
const _hoisted_16 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_17 = { class: "card-body p-4 text-center" }
const _hoisted_18 = { class: "fs-24 fw-bold mb-1" }
const _hoisted_19 = {
  key: 1,
  class: "col-lg-3 col-sm-6"
}
const _hoisted_20 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_21 = { class: "card-body p-4 text-center" }
const _hoisted_22 = { class: "fs-24 fw-bold mb-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageTitle, {
      pageTitle: "Dashboard Overview",
      subTitle: "Jurnalku Admin"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[0] || (_cache[0] = _createElementVNode("div", {
              class: "d-flex justify-content-center align-items-center bg-primary-transparent rounded-circle mx-auto mb-3",
              style: {"width":"60px","height":"60px"}
            }, [
              _createElementVNode("i", { class: "material-symbols-outlined fs-24 text-primary" }, "group")
            ], -1)),
            _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.stats.customers), 1),
            _cache[1] || (_cache[1] = _createElementVNode("span", { class: "fs-14 text-secondary" }, "Total Customers", -1))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _cache[2] || (_cache[2] = _createElementVNode("div", {
              class: "d-flex justify-content-center align-items-center bg-success-transparent rounded-circle mx-auto mb-3",
              style: {"width":"60px","height":"60px"}
            }, [
              _createElementVNode("i", { class: "material-symbols-outlined fs-24 text-success" }, "shopping_cart")
            ], -1)),
            _createElementVNode("h3", _hoisted_10, _toDisplayString(_ctx.stats.orders), 1),
            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "fs-14 text-secondary" }, "Total Orders", -1))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _cache[4] || (_cache[4] = _createElementVNode("div", {
              class: "d-flex justify-content-center align-items-center bg-warning-transparent rounded-circle mx-auto mb-3",
              style: {"width":"60px","height":"60px"}
            }, [
              _createElementVNode("i", { class: "material-symbols-outlined fs-24 text-warning" }, "build")
            ], -1)),
            _createElementVNode("h3", _hoisted_14, _toDisplayString(_ctx.stats.services), 1),
            _cache[5] || (_cache[5] = _createElementVNode("span", { class: "fs-14 text-secondary" }, "Active Services", -1))
          ])
        ])
      ]),
      (_ctx.isQc)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _cache[6] || (_cache[6] = _createElementVNode("div", {
                  class: "d-flex justify-content-center align-items-center bg-danger-transparent rounded-circle mx-auto mb-3",
                  style: {"width":"60px","height":"60px"}
                }, [
                  _createElementVNode("i", { class: "material-symbols-outlined fs-24 text-danger" }, "verified")
                ], -1)),
                _createElementVNode("h3", _hoisted_18, _toDisplayString(_ctx.stats.pendingQc), 1),
                _cache[7] || (_cache[7] = _createElementVNode("span", { class: "fs-14 text-secondary" }, "Antrean QC", -1))
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _cache[8] || (_cache[8] = _createElementVNode("div", {
                  class: "d-flex justify-content-center align-items-center bg-danger-transparent rounded-circle mx-auto mb-3",
                  style: {"width":"60px","height":"60px"}
                }, [
                  _createElementVNode("i", { class: "material-symbols-outlined fs-24 text-danger" }, "payments")
                ], -1)),
                _createElementVNode("h3", _hoisted_22, _toDisplayString(_ctx.stats.payments), 1),
                _cache[9] || (_cache[9] = _createElementVNode("span", { class: "fs-14 text-secondary" }, "Payments", -1))
              ])
            ])
          ]))
    ])
  ]))
}